import { render, staticRenderFns } from "./MovilServidor.vue?vue&type=template&id=6c7d450e&"
import script from "@/Servicios/MovilServidor.js?vue&type=script&lang=js&"
export * from "@/Servicios/MovilServidor.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports